import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=08f262db"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=08f262db&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports